import React, { useState, useEffect } from "react";
import { Card, Button, Modal, Table, Alert, Spinner } from "react-bootstrap";
import swal from "sweetalert";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
var FormData = require("form-data");
export default function PackageBanner() {
  const history = useHistory();
  const [url, setUrl] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [banners, setBanners] = useState("");
  const [image, setImage] = useState(null);
  const [imageData, setImageData] = useState(null);
  const [show, setShow] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [bannerId, setBannerId] = useState("");
  const [bannerCategory, setBannerCategory] = useState("");
  const [bannerImageKey, setBannerImageKey] = useState("");
  const handleShow = () => {
    setUpdateStatus(false);
    setShow(true);
    setDeleteStatus(false);
    setUrl("");
    setImageData(null);
  };
  const handleClose = () => {
    setShow(false);
  };
  function getData() {
    axios
      .get(Baseurl.baseurl3 + `/health/get-all-banner`)
      .then((res) => {
        console.log("result", res.data.details);
        setSpinner(false);
        setBanners(res.data.details);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }

  useEffect(() => {
    getData();
  }, []);
  const onChangePicture = (e) => {
    if (e.target.files[0].size / 1048576 < 3) {
      setImage(e.target.files[0]);
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          setImageData(reader.result);
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 3MB", "error", {
        button: "Done",
        timer: 2000,
      });
      setImageData(null);
    }
  };

  function saveBanner(e) {
    e.preventDefault();
    const data = new FormData();
    data.append("name", "Go_Health");
    data.append("image", image);
    data.append("url", url);
    var config = {
      method: "post",
      url: `${Baseurl.baseurl3}/health/add-banner`,
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();

          setImage(null);
          setImageData(null);
          setUrl("");

          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });

    handleClose();
  }
  function deleteBanner(e) {
    e.preventDefault();
    axios
      .delete(
        Baseurl.baseurl3 + `/health/delete-banner-by-id/${bannerId}`
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        handleClose();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }

  function updateBanner(e) {
    e.preventDefault();
    const data = new FormData();
    data.append("image", image);
    data.append("bannerImageKey", bannerImageKey);
    var config = {
      method: "put",
      url: `${Baseurl.baseurl3}/health/update-banner-by-id/${bannerId}`,
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();
          setImage(null);
          setImageData(null);
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });

    handleClose();
  }
  function updateBannerCategory(e) {
    e.preventDefault();
    let bannerData = {
      category: "Go_Health",
      url: url,
    };
    axios
      .put(
        Baseurl.baseurl3 + `/health/update-banner-category/${bannerId}`,
        bannerData
      )
      .then((response) => {
        if (response.data.status) {
          getData();

          setImage(null);
          setImageData(null);
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setUrl("");
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
  return (
    <Card>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Body>
          {deleteStatus ? (
            <h4>
              Are you sure !! you want to delete Banner
              <text className="text-danger ml-1">{bannerCategory}</text>
            </h4>
          ) : (
            <div>
              <div>
                <div className="row mb-4">
                  <label className="col-sm-4 mt-3">Id</label>
                  <input
                    value={url}
                    type="text"
                    className="form-control col-sm-6"
                    placeholder="enter Id"
                    onChange={(e) => setUrl(e.target.value)}
                    required
                  />
                  {updateStatus && (
                    <div className="col-sm-2">
                      <button
                        onClick={(e) => {
                          updateBannerCategory(e);
                        }}
                        className="btn btn-primary"
                      >
                        Update
                      </button>
                    </div>
                  )}
                </div>

                <div className="form-group row">
                  <label
                    className="col-sm-4 col-form-label"
                    htmlFor="val-range"
                  >
                    Banner Image
                    <span className="text-danger">*</span>
                  </label>
                  <div classname="col-sm-4">
                    <div className="register_profile_image mt-2">
                      <input
                        id="profilePic"
                        type="file"
                        onChange={(e) => {
                          onChangePicture(e);
                        }}
                      />
                    </div>
                    {imageData && (
                      <div
                        style={{
                          marginTop: "5px",
                          width: 180,
                          height: 100,
                          aspectRatio: 1 * 1.4,
                        }}
                        className="previewProfilePic"
                      >
                        <img
                          alt=""
                          className="playerProfilePic_home_tile"
                          style={{
                            resizeMode: "cover",
                            width: "100%",
                            height: "100%",
                          }}
                          src={imageData}
                        />
                      </div>
                    )}
                  </div>
                  {updateStatus && (
                    <div className="col-sm-2 mt-5">
                      <button
                        onClick={(e) => {
                          updateBanner(e);
                        }}
                        className="btn btn-primary mt-3"
                      >
                        Update
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {deleteStatus ? (
            <Button
              variant="primary"
              onClick={(e) => {
                deleteBanner(e);
              }}
            >
              Delete
            </Button>
          ) : (
            <>
              {updateStatus ? null : (
                <Button
                  variant="primary"
                  onClick={(e) => {
                    saveBanner(e);
                  }}
                >
                  submit
                </Button>
              )}
            </>
          )}

          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div>
        <div style={{ padding: 20 }} className="flex-container">
          <div>
            <div>
              <button
                className="btn btn-primary float-right"
                onClick={handleShow}
              >
                Add Banner
              </button>
            </div>
            <Table>
              <thead>
                <div className="row">
                  <div className="col-sm-3">
                    <strong>Category</strong>
                  </div>
                  <div className="col-sm-3">
                    <strong>Image</strong>
                  </div>
                  <div className="col-sm-3">
                    <strong>Url</strong>
                  </div>
                </div>
              </thead>
            </Table>

            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <>
                {banners &&
                  banners.map((word) => {
                    return (
                      <Card
                        style={{
                          color: "white",
                          background:
                            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
                        }}
                      >
                        <Card.Body>
                          <div className="row">
                            <div className="col-sm-2 mt-5">
                              {word.Category ? (
                                <div key={word._id} className="flex-item">
                                  {word.Category}
                                </div>
                              ) : (
                                <div className="flex-item">----</div>
                              )}
                            </div>
                            <div className="col-sm-3">
                              <div
                                style={{
                                  marginTop: "5px",
                                  width: 220,
                                  height: 100,
                                  aspectRatio: 1 * 1.4,
                                }}
                                className="col-sm-12"
                              >
                                <img
                                  style={{
                                    resizeMode: "cover",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                  class="img-fluid"
                                  alt=""
                                  src={word.Banner}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4 mt-4">
                              <div className="flex-item">{word.Url}</div>
                            </div>
                            <div className="mt-4">
                              <button
                                onClick={() => {
                                  setBannerId(word._id);
                                  setUpdateStatus(true);
                                  setShow(true);
                                  setImageData(word.Banner);
                                  //setBannerImage(word.Banner);
                                  setBannerImageKey(word.BannerKey);
                                  setDeleteStatus(false);
                                  setUrl(word.Url);
                                }}
                                className="btn btn-primary "
                              >
                                Update
                              </button>
                              <button
                                onClick={() => {
                                  setBannerCategory(word.Category);
                                  setBannerId(word._id);
                                  setDeleteStatus(true);
                                  setShow(true);
                                }}
                                className="btn btn-primary ml-2"
                              >
                                delete
                              </button>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    );
                  })}
                {!banners && (
                  <Alert
                    variant="success"
                    className="alert-dismissible fade show text-center"
                  >
                    Add Banners
                  </Alert>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
}
